<template>
  <div class="home">
    <Banner
    :words="bannerTitle"
    :pictures="bannerPictures" />

    <ListPicture
    :topictitle="listTitle"
    :listwords="listWords" />

    <Fixedbg :pic="titleBackground">
      <h1 slot="title">千農科技</h1>
      <!-- <h2 slot="subtitle">This is a big title2.</h2> -->
      <!-- <h3 slot="content">welcome</h3> -->
      <template slot="btn">button</template>
    </Fixedbg>

    <Quartercard
    :quarterTitle="quarterTitle"
    :quarterWords="quarterWords" />

    <Picturecard
    :picturecardTopic="picturecardTopic"
    :picturecardWord="picturecardWord"/>

    <MiniPicture
    :MiniPicture="MiniPicture"/>

    <Form />
    <Footer />


  </div>
</template>

<script>
// @ is an alias to /src
import Banner from '@/components/Banner_area.vue'; // banner 二選一
// import Banner from '@/components/Banner_parts.vue';
import ListPicture from '@/components/Area_listPicture.vue';
import Fixedbg from '@/components/Area_fixedbg.vue';
import Quartercard from '@/components/Quartercard_area.vue';
import Picturecard from '@/components/Picturecard_area.vue';
import MiniPicture from '@/components/Area_miniPicture.vue';
import Form from '@/components/Form_area.vue';
import Footer from '@/components/footer_information.vue';

import products1and1 from '@/assets/products/products-1/product1.png';
import products1and2 from '@/assets/products/products-1/product2.png';
import products1and3 from '@/assets/products/products-1/product3.png';
import products1and4 from '@/assets/products/products-1/product4.png';
import products1and5 from '@/assets/products/products-1/product5.png';
import products1and6 from '@/assets/products/products-1/product6.png';

import products2and1 from '@/assets/products/products-2/product1.png';
import products2and2 from '@/assets/products/products-2/product2.png';
import products2and3 from '@/assets/products/products-2/product3.png';

import products3and1 from '@/assets/products/products-3/product1.png';
import products3and2 from '@/assets/products/products-3/product2.png';
import products3and3 from '@/assets/products/products-3/product3.png';

import products4and1 from '@/assets/products/products-4/product1.png';
import products4and2 from '@/assets/products/products-4/product2.png';
import products4and3 from '@/assets/products/products-4/product3.png';
import products4and4 from '@/assets/products/products-4/product4.png';
import products4and5 from '@/assets/products/products-4/product5.png';

import products5and1 from '@/assets/products/products-5/product1.png';
import products5and2 from '@/assets/products/products-5/product2.png';

import products6and1 from '@/assets/products/products-6/product1.png';
import products6and2 from '@/assets/products/products-6/product2.png';

import products7and1 from '@/assets/products/products-7/product1.png';
import products7and2 from '@/assets/products/products-7/product2.png';
import products7and3 from '@/assets/products/products-7/product3.png';

export default {
  data() {
    return {
      bannerTitle: {
        title: '千農科技',
        smalltitle: 'ChainFarms',
        subtitle: '千農科技有限公司',
        content: '新竹縣竹北市縣政二路488號2樓',
      },
      bannerPictures: [
        products1and1,
        products2and1,
        products3and1,
        products4and1,
        products5and1,
      ],
      titleBackground: {
        url: products1and1,
        fixed: true,
      },
      listTitle: {
        title: '千農科技',
      },
      listWords: {
        // title: '',
        // subtitle: '',
        // itemarray: [
        //   '這是第1點項目這是第1點項目',
        //   '這是第2點項目這是第2點項目',
        //   '這是第3點項目這是第3點項目',
        //   '這是第4點項目這是第4點項目',
        //   '這是第5點項目這是第5點項目',
        //   '這是第6點項目這是第6點項目',
        //   '這是第7點項目這是第7點項目',
        //   '這是第8點項目這是第8點項目',
        // ],
        content: '由於全球氣候變遷，使得天氣變化巨大、難以預料，許多農民藉由過去的傳統經驗已經不足以應付，因此農業也應該有相應的措施，藉由科技來蒐集農場資料，透過資料的分析和幫助，期望能達到作物質量上的成長，農業與科技結合已成為全球趨勢。',
        summary: '智慧農業整合物聯網，同時擁有軟體與硬體，從感測、監控、分析到應用，都有一套完整的解決方案，供農民應對各種農業的核心問題、了解農民的真實需求。',
        picture: products1and1,
        button: '領取優惠',
      },
      quarterTitle: {
        title: '提供服務',
      },
      quarterWords: [
        {
          // who: '提供服務',
          things: ['您將會知道自己的作物將在何時收成最佳', '隨時監測作物的狀況、取得環境數據，您將可以預估作物產量', '與天氣預報結合，您將順利避免不佳的天候、降低農損', '建立完整資料庫、將擁有完整連續的資料', '農場幅員廣大，監測與拍攝功能將即時回傳農田中的狀況，您將不用再耗費勞力成本管理了'],
          button: '請按1',
          buttonUrl: '/services',
        },
        // {
        //   who: '提供契作企業服務',
        //   things: ['建立完整資料庫、將擁有完整連續的資料', '農場幅員廣大，監測與拍攝功能將即時回傳農田中的狀況，您將不用再耗費勞力成本管理了'],
        //   button: '請按2',
        //   buttonUrl: '/services/forsomeone2',
        // },
      ],
      picturecardTopic: {
        title: '圖片介紹',
        url: products1and1,
      },
      picturecardWord: [
        {
          title: 'LoRaWAN環境感知感應器集中器',
          content:
            '',
          picture: products1and1,
        },
        {
          title: '土壤感測器組',
          content:
            '',
          picture: products2and1,
        },
        {
          title: '簡易型氣象站',
          content:
            '',
          picture: products3and1,
        },
        {
          title: '微氣象站組',
          content:
            '',
          picture: products4and1,
        },
        {
          title: '人工智慧自動澆灌系統',
          content:
            '',
          picture: products5and1,
        },
        {
          title: '通訊開發模組',
          content:
            '',
          picture: products6and1,
        },
      ],
      MiniPicture: {
        title: '產品',
        pictures: [
          {
            name: 'products1and1',
            photo: products1and1,
            id: 1,
          },
          {
            name: 'products1and2',
            photo: products1and2,
            id: 2,
          },
          {
            name: 'products1and3',
            photo: products1and3,
            id: 3,
          },
          {
            name: 'products1and4',
            photo: products1and4,
            id: 4,
          },
          {
            name: 'products1and5',
            photo: products1and5,
            id: 5,
          },
          {
            name: 'products1and6',
            photo: products1and6,
            id: 6,
          },
          {
            name: 'products2and1',
            photo: products2and1,
            id: 7,
          },
          {
            name: 'products2and2',
            photo: products2and2,
            id: 8,
          },
          {
            name: 'products2and3',
            photo: products2and3,
            id: 9,
          },
          {
            name: 'products3and1',
            photo: products3and1,
            id: 10,
          },
          {
            name: 'products3and2',
            photo: products3and2,
            id: 11,
          },
          {
            name: 'products3and3',
            photo: products3and3,
            id: 12,
          },
          {
            name: 'products4and1',
            photo: products4and1,
            id: 13,
          },
          {
            name: 'products4and2',
            photo: products4and2,
            id: 14,
          },
          {
            name: 'products4and3',
            photo: products4and3,
            id: 15,
          },
          {
            name: 'products4and4',
            photo: products4and4,
            id: 16,
          },
          {
            name: 'products4and5',
            photo: products4and5,
            id: 17,
          },
          {
            name: 'products5and1',
            photo: products5and1,
            id: 18,
          },
          {
            name: 'products5and2',
            photo: products5and2,
            id: 19,
          },
          {
            name: 'products6and1',
            photo: products6and1,
            id: 20,
          },
          {
            name: 'products6and2',
            photo: products6and2,
            id: 21,
          },
          {
            name: 'products7and1',
            photo: products7and1,
            id: 22,
          },
          {
            name: 'products7and2',
            photo: products7and2,
            id: 23,
          },
          {
            name: 'products7and3',
            photo: products7and3,
            id: 24,
          },
        ],
      },
    };
  },
  components: {
    Banner,
    ListPicture,
    Fixedbg,
    Quartercard,
    Picturecard,
    MiniPicture,
    Form,
    Footer,
  },
};
</script>

<style lang="scss" scoped>
</style>
